import React, { useEffect } from 'react';

type Props = {
  node: IStorageJavascriptFeature;
};

const StorageJavascriptFeature = function ({ node: javascriptFeature }: Props) {
  let src = '';
  let id = '';

  switch (javascriptFeature.feature) {
    case 'purina_farms_calendar':
      id = 'app';
      src = 'https://purina.ungerboeck.com/prod_calendar_service/app/js/main.js';
      break;
    default:
      break;
  }

  useEffect(() => {
    if (src) {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;

      document.body.appendChild(script);
    }
  }, [src]);

  return (
    <div id={javascriptFeature.component_id} data-id={javascriptFeature.drupal_id}>
      {!!id && <div id={id} />}
    </div>
  );
};

export default StorageJavascriptFeature;
